export const downtimeStyles = (theme) => ({
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "1.5rem",
    backgroundColor: theme.background,
  },
  section: {
    marginBottom: "2rem",
    padding: "1.5rem",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `1px solid ${theme.border}`,
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "1rem",
    borderBottom: `2px solid ${theme.primary}`,
    paddingBottom: "0.5rem",
  },
  activityCard: {
    padding: "1.5rem",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    marginBottom: "1rem",
  },
  inputGroup: {
    marginBottom: "1rem",
  },
  label: {
    display: "block",
    fontSize: "0.875rem",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "0.5rem",
  },
  input: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "0.875rem",
  },
  select: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "0.875rem",
  },
  textarea: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "0.875rem",
    resize: "none",
    height: "80px",
  },
  activityDescription: {
    padding: "1rem",
    backgroundColor: theme.primary + "10",
    border: `1px solid ${theme.primary + "30"}`,
    borderRadius: "6px",
    fontSize: "0.875rem",
    color: theme.text,
    lineHeight: "1.5",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
  diceAssignment: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem",
    marginTop: "1rem",
  },
  assignedDice: {
    padding: "1rem",
    backgroundColor: theme.success + "15",
    borderRadius: "8px",
    border: `2px solid ${theme.success}`,
    textAlign: "center",
    color: theme.success,
    maxWidth: "450px",
  },
  diceValue: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.success,
    marginBottom: "0.5rem",
  },
  total: {
    fontSize: "1rem",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "0.5rem",
  },
  removeButton: {
    padding: "0.25rem 0.75rem",
    backgroundColor: theme.error + "15",
    color: theme.error,
    border: `1px solid ${theme.error}`,
    borderRadius: "4px",
    fontSize: "0.75rem",
    cursor: "pointer",
    marginTop: "0.5rem",
  },
  button: {
    padding: "0.75rem 1.5rem",
    borderRadius: "8px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  secondaryButton: {
    backgroundColor: theme.warning,
    color: "white",
  },
  successButton: {
    backgroundColor: theme.success,
    color: "white",
  },
  actionButtons: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  makeSpellContainer: {
    backgroundColor: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "1rem",
    marginTop: "0.5rem",
  },
  progressContainer: {
    marginTop: "1rem",
    padding: "1rem",
    backgroundColor: theme.background,
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
  },
  progressHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
  },
  progressTitle: {
    margin: 0,
    fontSize: "1.1rem",
    fontWeight: "600",
    color: theme.text,
  },
  progressBadge: {
    backgroundColor: theme.primary,
    color: "white",
    padding: "0.25rem 0.75rem",
    borderRadius: "12px",
    fontSize: "0.875rem",
    fontWeight: "600",
  },
  checksList: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    marginBottom: "1rem",
  },
  checkItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.75rem",
    padding: "0.75rem",
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
  },
  checkItemCompleted: {
    backgroundColor: theme.primary + "10",
    borderColor: theme.primary,
  },
  checkItemCurrent: {
    backgroundColor: theme.secondary + "10",
    borderColor: theme.secondary,
  },
  checkIcon: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: theme.primary,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "bold",
    flexShrink: 0,
  },
  checkContent: {
    flex: 1,
  },
  checkName: {
    fontSize: "0.95rem",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "0.25rem",
  },
  checkDescription: {
    fontSize: "0.85rem",
    color: theme.textSecondary,
    lineHeight: 1.4,
  },
  currentCheckInfo: {
    padding: "1rem",
    backgroundColor: theme.secondary + "10",
    border: `1px solid ${theme.secondary}`,
    borderRadius: "6px",
  },
  currentCheckTitle: {
    fontSize: "1rem",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "0.5rem",
  },
  dcInfo: {
    fontSize: "0.95rem",
    color: theme.text,
    marginBottom: "0.5rem",
  },
  checkNote: {
    fontSize: "0.85rem",
    color: theme.textSecondary,
    fontStyle: "italic",
  },
  completionMessage: {
    padding: "1rem",
    backgroundColor: theme.primary + "10",
    border: `1px solid ${theme.primary}`,
    borderRadius: "6px",
    textAlign: "center",
    color: theme.text,
  },
});
